import { memo, useEffect } from 'react';
import { Error as Auth0Error } from '@auth0/auth0-acul-js';
import { Toaster } from '@page/ui';

import { notifyErrors } from '@page/auth/services/errorCodes';
import { ExternalLayout } from '@page/core/components/layout/external/ExternalLayout';

interface AuthLayoutProps {
  children: React.ReactNode;
  errors?: Auth0Error[] | null;
  hideIntro?: boolean;
}

const AuthLayoutBase = ({ children, errors, hideIntro = false }: AuthLayoutProps) => {
  useEffect(() => {
    if (!errors) return;

    notifyErrors(errors);
  }, [errors]);

  return (
    <ExternalLayout additionalContent={<Toaster />} hideIntro={hideIntro}>
      {children}
    </ExternalLayout>
  );
};

export const AuthLayout = memo(AuthLayoutBase);
